import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const getMyDetail = (params, urlParams) => {
  return axios.request({
    url: '/cpc/realtimemonitorsubscribe/getmydetail' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const saveRealtimeMonitorSubscribe = (params, urlParams) => {
  return axios.request({
    url: '/cpc/realtimemonitorsubscribe/saverealtimemonitorsubscribe' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

